import { render, staticRenderFns } from "./FleetTruckUploads.vue?vue&type=template&id=36fbb427&scoped=true&"
import script from "./FleetTruckUploads.vue?vue&type=script&lang=js&"
export * from "./FleetTruckUploads.vue?vue&type=script&lang=js&"
import style0 from "./FleetTruckUploads.vue?vue&type=style&index=0&id=36fbb427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbb427",
  null
  
)

export default component.exports